import { styled } from '@mui/material/styles';
import { Tab as MuiTab, useMediaQuery, useTheme } from '@mui/material';
import { size, COLORS } from '../../utils';

const Tab = styled(MuiTab, {
  shouldForwardProp: (prop) => prop !== 'ismobile',
})(({ theme, ismobile }) => ({
  fontFamily: 'Archia',
  color: COLORS.C2,
  fontWeight: 500,
  fontSize: size({ p: 1 }),
  textTransform: 'none',
  padding: `${size({ p: 2, h: true })} ${size({ p: 3 })}`,
  ...(ismobile && {
    fontSize: size({ p: 2.4 }),
  }),
  '&:hover': {
    backgroundColor: '#00000010',
  },
  '&.Mui-selected:hover': {
    backgroundColor: '#00000010',
  },
  '&.Mui-selected': {
    color: COLORS.C2,
    fontWeight: 900,
  },
}));

const StyledTab = (props) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return <Tab {...props} ismobile={isMobile} />;
};

export default StyledTab;
